<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'package-review-list'"
      ></vdr-action-bar-items>
      
      <button
        class="button secondary mr-1"
        (click)="bulkDeletePackageReviews()"
        [disabled]="selectionManager.selection.length === 0"
        *vdrIfPermissions="['DeletePackageReview']"
      >
        {{ "common.delete" | translate }}
      </button>

      <button
        class="button primary mr-1"
        (click)="recalculatePackageReviews()"
        [disabled]="selectionManager.selection.length === 0"
        *vdrIfPermissions="['UpdatePackageReview']"
      >
        {{ "package.recalculate-split-orders" | translate }}
      </button>

      <button
        class="button primary mr-1"
        (click)="bulkUpdateRule()"
        [disabled]="selectionManager.selection.length === 0"
        *vdrIfPermissions="['UpdatePackageReview']"
      >
        {{ "package.bulk-update-rule" | translate }}
      </button>

      <button
        class="button primary mr-1"
        (click)="bulkAddSku()"
        [disabled]="selectionManager.selection.length === 0"
        *vdrIfPermissions="['UpdatePackageReview']"
      >
        {{ "package.bulk-add-sku" | translate }}
      </button>

      <button
        class="button primary mr-1"
        (click)="bulkAddFreeGift()"
        [disabled]="selectionManager.selection.length === 0"
        *vdrIfPermissions="['UpdatePackageReview']"
      >
        {{ "package.bulk-add-free-gift" | translate }}
      </button>

      <button
        class="button primary mr-1"
        (click)="bulkUpdateSku()"
        [disabled]="selectionManager.selection.length === 0"
        *vdrIfPermissions="['UpdatePackageReview']"
      >
        {{ "package.bulk-update-sku" | translate }}
      </button>

      <button class="button primary mr-1" (click)="performSplitOrder()">
        {{ "nav.package" | translate }}
      </button>
      <button
        class="button primary mr-1"
        (click)="createPackagesFromOrders()"
        [disabled]="selectionManager.selection.length === 0"
        *vdrIfPermissions="['ReadPackageReview']"
      >
        {{ "package.create-packages" | translate }}
      </button>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-split-view
  [rightPanelOpen]="activeRowId$ | async"
  (closeClicked)="closeContents()"
>
  <ng-template vdrSplitViewLeft>
    <custom-data-table
      class="mt-2"
      id="wh-product-table"
      [items]="items$ | async"
      [itemsPerPage]="itemsPerPage$ | async"
      [totalItems]="totalItems$ | async"
      [currentPage]="currentPage$ | async"
      [filters]="filters"
      [expandedRowIndex]="expandedRowIndex"
      (pageChange)="setPageNumber($event)"
      (itemsPerPageChange)="setItemsPerPage($event)"
    >
      <vdr-bulk-action-menu
        locationId="package-review-list"
        [hostComponent]="this"
        [selectionManager]="selectionManager"
      ></vdr-bulk-action-menu>
      <vdr-dt2-search
        [searchTermControl]="searchTermControl"
        [searchTermPlaceholder]="'Search by Product SKU'"
      ></vdr-dt2-search>

      <expand-div>
        <ng-template let-item="item" let-index="index">
          <package-review-order-expand-content
            [item]="item"
            [index]="index"
            (editLine)="editSkuLine($event)"
            [inDetail]="false"
          />
        </ng-template>
      </expand-div>

      <vdr-dt2-column
        [heading]="'common.id' | translate"
        id="id"
        [hiddenByDefault]="false"
        [sort]="sorts.get('id')"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.id }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Order'"
        id="created-at"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          <a
            class="button-ghost"
            [routerLink]="['/orders', packageReview.orderId]"
          >
            <span>{{ packageReview.order.code }}</span>
            <clr-icon shape="arrow right"></clr-icon>
          </a>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.total-quantity' | translate"
        id="total-quantity"
        [hiddenByDefault]="false"
        [sort]="sorts.get('totalQuantity')"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.totalQuantity }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.total-weight' | translate"
        id="total-weight"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.totalWeight }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.total-packages' | translate"
        id="total-weight"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.totalPackages }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.average-variant-quantity' | translate"
        id="total-weight"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.averageVariantQuantityPerPackage }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.average-gift-quantity' | translate"
        id="total-weight"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.averageGiftQuantityPerPackage }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.average-weight' | translate"
        id="total-weight"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.averageWeightPerPackage }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Detail'"
        id="view-contents"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item" let-i="index">
          <!-- <a
          class="button-small bg-weight-150"
          [routerLink]="['./', { contents: inbounding.id }]"
          queryParamsHandling="merge"
        >
          <span>{{ "common.view-contents" | translate }}</span>
          <clr-icon shape="file-group"></clr-icon>
        </a> -->

          <button class="button-ghost" (click)="setRowExpand(i)">
            <span>{{ "common.view-contents" | translate }}</span>
            <clr-icon shape="file-group"></clr-icon>
          </button>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.created-at' | translate"
        id="created-at"
        [hiddenByDefault]="false"
        [sort]="sorts.get('createdAt')"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.createdAt | localeDate : "short" }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Updated At'"
        id="updated-at"
        [hiddenByDefault]="true"
        [sort]="sorts.get('updatedAt')"
      >
        <ng-template let-packageReview="item">
          {{ packageReview.updatedAt | localeDate : "short" }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.customer-type' | translate"
        id="id"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          <is-cooperate-column [rowItem]="packageReview.order.customer"></is-cooperate-column>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Detail'"
        id="detail"
        [hiddenByDefault]="false"
      >
        <ng-template let-packageReview="item">
          <a
            class="button-ghost"
            [routerLink]="['/extensions/package-reviews', packageReview.id]"
          >
            <span>detail</span>
            <clr-icon shape="arrow right"></clr-icon>
          </a>
        </ng-template>
      </vdr-dt2-column>
    </custom-data-table>
  </ng-template>
  <ng-template vdrSplitViewRight [splitViewTitle]="'  '">
    <h1>Hello</h1>
    <h1>Hello</h1>
  </ng-template>
</vdr-split-view>
